import {EntityData, field} from "@fedeltapointofsale/data-client";

export class ReceiveOrderData extends EntityData<ReceiveOrderData> {
    @field receivingId: number;
}
